import { render } from '@wordpress/element';
import { createRoot as wpCreateRoot } from '@wordpress/element';
import InteractiveDNAComponent from './react';

function mount(container: Element, node: JSX.Element): void {
  const maybeCreateRoot = wpCreateRoot as unknown as
    | ((c: Element | DocumentFragment) => { render: (n: JSX.Element) => void })
    | undefined;

  if (typeof maybeCreateRoot === 'function') {
    const root = maybeCreateRoot(container);
    root.render(node);
  } else {
    // React 17 pathway
    render(node, container as any);
  }
}

const interactiveDNA = (): void => {
  const sections = document.querySelectorAll<HTMLElement>(
    '[data-interactive-dna]'
  );
  if (!sections.length) return;

  sections.forEach((section) => {
    // Default (Behind)
    let position = 'center';

    let aspectRatio = 3;
    let rotationDeg = -8;
    let dotSize = 3.5;
    let amplitudeBase = 0.19;
    let turns = 2.5;

    let colour = 'light';

    const reactContainer = section.querySelector(
      '[data-interactive-dna-container]'
    );

    if (!reactContainer) return;

    if (reactContainer) {
      const aspectRatioAttr = reactContainer.getAttribute(
        'data-interactive-dna-aspect-ratio'
      );
      const dotSizeAttr = reactContainer.getAttribute(
        'data-interactive-dna-dot-size'
      );
      const rotationDegAttr = reactContainer.getAttribute(
        'data-interactive-dna-rotation-deg'
      );
      const amplitudeBaseAttr = reactContainer.getAttribute(
        'data-interactive-dna-amplitude-base'
      );
      const turnsAttr = reactContainer.getAttribute(
        'data-interactive-dna-turns'
      );
      const colourAttr = reactContainer.getAttribute(
        'data-interactive-dna-colour'
      );

      if (aspectRatioAttr !== null) {
        aspectRatio = parseFloat(aspectRatioAttr);
      }
      if (dotSizeAttr !== null) {
        dotSize = parseFloat(dotSizeAttr);
      }
      if (rotationDegAttr !== null) {
        rotationDeg = parseInt(rotationDegAttr);
      }
      if (amplitudeBaseAttr !== null) {
        amplitudeBase = parseFloat(amplitudeBaseAttr);
      }
      if (turnsAttr !== null) {
        turns = parseFloat(turnsAttr);
      }
      if (rotationDeg == -108) {
        position = 'left';
      }
      if (rotationDeg == 108) {
        position = 'right';
      }
      if (colourAttr) {
        colour = colourAttr;
      }
    }

    mount(
      reactContainer,
      <InteractiveDNAComponent
        position={position}
        aspectRatio={aspectRatio}
        dotSize={dotSize}
        rotationDeg={rotationDeg}
        amplitudeBase={amplitudeBase}
        turns={turns}
        colour={colour}
      />
    );
  });
};

export default interactiveDNA;
